import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor() {}
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      if (request.url.includes('aiprocure.elitetraveltech.in')) {
        const merlinSession = sessionStorage.getItem('merlin_session_id') || localStorage.getItem('merlin_session_id');
        if (merlinSession && !request.headers.has('x-session-id')) {
          const mcpReq = request.clone({
            setHeaders: {
              'x-session-id': merlinSession
            }
          });
          return next.handle(mcpReq);
        }
        return next.handle(request);
      }
      const signIn: any = sessionStorage.getItem('user_details') || localStorage.getItem('user_details');
      const singInUser = JSON.parse(signIn);
      if (!singInUser) {
        return next.handle(request);
      } else {
        const company_id = singInUser.company_id || singInUser.companyId;
        const modifyReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${singInUser.token}`,
            'company_id': `${company_id}`
          }
        });
        return next.handle(modifyReq);
      }
    }
  }